import CandidateFiltersManager, {
  CandidateFiltersManagerProps,
} from './CandidateFiltersManager.container';

export type CandidateFiltersManagerType = CandidateFiltersManagerProps;

export default CandidateFiltersManager;
